import { useCallback, useEffect, useRef } from 'react';

export const konamiCode = [
    'ArrowUp',
    'ArrowUp',
    'ArrowDown',
    'ArrowDown',
    'ArrowLeft',
    'ArrowRight',
    'ArrowLeft',
    'ArrowRight',
    'b',
    'a',
];

export const useSecretCode = ({ onComplete, inputCode = konamiCode }) => {
    const index = useRef(0);
    const code = useRef(inputCode);
    const callback = useRef(onComplete);

    const keyHandler = useCallback(
        (event) => {
            const { key } = event;
            if (key !== code.current[index.current]) {
                index.current = 0;
                return;
            }
            index.current += 1;
            if (index.current === code.current.length) {
                callback?.current?.();
                index.current = 0;
            }
        },
        [callback]
    );

    useEffect(() => {
        window?.addEventListener?.('keydown', keyHandler);
        return () => {
            window?.removeEventListener?.('keydown', keyHandler);
        };
    }, [keyHandler]);
};
